import script from "./yijian.vue?vue&type=script&setup=true&lang=js"
export * from "./yijian.vue?vue&type=script&setup=true&lang=js"

import "./yijian.vue?vue&type=style&index=0&id=1e456795&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e456795"]])

export default __exports__